export default {
  ENVIRONMENT_LOAD: Symbol('ENVIRONMENT_LOAD'),
};
